import React, { useEffect, useState } from "react";
import {
    EuiOverlayMask,
    EuiModalHeader,
    EuiModal,
    EuiModalHeaderTitle,
    EuiButtonEmpty,
    EuiModalBody,
    EuiModalFooter,
    EuiButton,
} from "@elastic/eui";
import DropoffsForm from "./DropoffsForm";
import { useIntl } from "react-intl";
const generateDropoffsEntities = ({ location, city, id, category }, i) => {
    return {
        locationId: location.id ? +location.id : null,
        cityId: city.id ? +city.id : null,
        pointType: "dropoff",
        position: i + 2,
        locationCategoryId: category.id ? +category.id : null,
        ...(id && { id: +id }),
    };
};
const mapDropoffEntity = ({
    id,
    canModify,
    locationAttributes,
    cityId,
    cityName,
    governorateId,
    governorateName,
}) => {
    const cId = locationAttributes
        ? locationAttributes.data.attributes.cityId &&
          "" + locationAttributes.data.attributes.cityId
        : "" + cityId;
    const cName = locationAttributes ? locationAttributes.data.attributes.cityName : cityName;
    const locId = locationAttributes && "" + locationAttributes.data.id;
    const locName =
        locationAttributes &&
        (locationAttributes.data.attributes.nameAr ||
            locationAttributes.data.attributes.name ||
            locationAttributes.data.attributes.address);
    const govId = locationAttributes
        ? locationAttributes.data.attributes.governorateId &&
          "" + locationAttributes.data.attributes.governorateId
        : "" + governorateId;
    const govName = locationAttributes
        ? locationAttributes.data.attributes.governorateName
        : governorateName;
    const catId =
        locationAttributes &&
        locationAttributes.data.attributes.locationCategoryId &&
        "" + locationAttributes.data.attributes.locationCategoryId;
    const catName = locationAttributes && locationAttributes.data.attributes.locationCategoryName;
    return {
        id,
        canModify,
        city: {
            id: cId,
            name: cName || "",
        },
        location: {
            id: locId,
            name: locName || "",
        },
        governorate: {
            id: govId,
            name: govName || "",
        },
        category: {
            id: catId,
            name: catName || "",
        },
    };
};

const isDropoffsChanged = (defaultValue, dropOffs) => {
    // CREATE or DELETE point
    if (defaultValue?.length !== dropOffs.length) {
        return true;
    }
    // if point location is UPDATED
    return defaultValue.some((tripPoint) => {
        const dropoffCurrentValue = dropOffs.find((dropoff) => dropoff.id === tripPoint.id);
        return +dropoffCurrentValue?.location?.id !== tripPoint.locationId;
    });
};
export const AddDropOffsModal = ({
    tripId,
    pickupPoint,
    canAppend,
    canModify,
    closeModal,
    saveDropoffs,
    defaultValue,
    onDropoffDelete,
    organizationId,
    tripType,
}) => {
    const [dropOffsForm, setDropOffsForm] = useState(
        defaultValue?.length ? defaultValue.map(mapDropoffEntity) : []
    );
    const intl = useIntl();
    useEffect(() => {
        if (defaultValue) {
            setDropOffsForm(defaultValue?.length ? defaultValue.map(mapDropoffEntity) : []);
        }
    }, [defaultValue]);
    const handleDropoffsChange = (value) => {
        setDropOffsForm(value);
    };
    return (
        <EuiOverlayMask>
            <EuiModal
                onClose={closeModal}
                initialFocus="[name=popswitch]"
            >
                <EuiModalHeader>
                    <EuiModalHeaderTitle>
                        {intl.formatMessage(
                            { id: "trip-dropoffs.trip-dropoffs" },
                            { number: tripId }
                        )}
                    </EuiModalHeaderTitle>
                </EuiModalHeader>
                <EuiModalBody>
                    <DropoffsForm
                        branchLocation={pickupPoint}
                        canAppend={canAppend}
                        selectedDropOffs={dropOffsForm}
                        onChange={handleDropoffsChange}
                        onDelete={onDropoffDelete}
                        organizationId={organizationId}
                        tripType={tripType}
                    />
                </EuiModalBody>
                <EuiModalFooter>
                    <EuiButtonEmpty
                        size="s"
                        onClick={closeModal}
                    >
                        {intl.formatMessage({ id: "misc.cancel" })}
                    </EuiButtonEmpty>
                    <EuiButton
                        size="s"
                        onClick={() => saveDropoffs(dropOffsForm.map(generateDropoffsEntities))}
                        isDisabled={false}
                        fill
                    >
                        {intl.formatMessage({ id: "misc.save" })}
                    </EuiButton>
                </EuiModalFooter>
            </EuiModal>
        </EuiOverlayMask>
    );
};
